// The picker for adding people to a picture's faces: the characters the picture was painted from first, then the rest
// of the library, newest first. Picking someone puts their face on; unpicking takes it off.
import { useLibrary } from "../../library/store";
import { byRecent } from "../../model/library";
import type { PaintSource, PlacedFace } from "../../model/timeline";
import { RefPicker, type MakerGroup } from "../images/ImageMaker";
import { refCharacterIds, useCharacters } from "../timeline/pages/shared";

export function CastPicker({ faces, refs, onAdd, onDrop, onClose }: {
  faces: PlacedFace[]; refs: PaintSource[]; onAdd: (id: string) => void; onDrop: (id: string) => void; onClose: () => void;
}) {
  const lib = useLibrary();
  const withPicture = useCharacters().filter(c => c.picture.src).sort(byRecent);
  const refIds = refCharacterIds(lib, refs);
  const cast: MakerGroup = {
    key: "character", title: "Characters", kind: "character",
    items: [...withPicture.filter(c => refIds.includes(c.id)), ...withPicture.filter(c => !refIds.includes(c.id))].map(c => ({ src: c.picture.src, name: c.name, kind: "character" })),
  };
  const onPicture = withPicture.filter(c => faces.some(f => f.char === c.id)).map(c => ({ src: c.picture.src, name: c.name, kind: "character" as const }));
  const toggle = (r: { src: string }) => {
    const id = withPicture.find(c => c.picture.src === r.src)?.id;
    if (id) (faces.some(f => f.char === id) ? onDrop(id) : onAdd(id));
  };
  return <RefPicker group={cast} refs={onPicture} onToggle={toggle} onClose={onClose} />;
}
